module.exports = "<div class=\"col-md-4\" ng-repeat=\"item in $ctrl.postByCategory\">\r\n   <div class=\"feed__blog-item\">\r\n      <div class=\"feed__blog-image\">\r\n         <img class=\"img-responsive\" ui-sref=\"home.blogDetail({blogSlug : item.slug})\" src=\"{{ item.imagen }}\">\r\n      </div>\r\n      <h4 class=\"feed__blog-title small\">{{ item.nombre }}</h4>\r\n      <p class=\"feed__blog-text\">{{ item.descripcion }}</p>\r\n      <a class=\"feed__blog-link\" ui-sref=\"home.blogDetail({blogSlug : item.slug})\">ver más</a>\r\n   </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/category/box-post-by-category/templates/box-post-t1-view.html
 ** module id = 771
 ** module chunks = 0
 **/